const lazyLoad = () => {
    $(window).on('load scroll resize', function() {
		$('.u__lazy-load:visible').each(function() {
			if ( isVisible($(this)) ) {
				if ( $(this).data('srcset') ) {
					$(this).attr('srcset', $(this).data('srcset'));
					$(this).removeAttr('data-srcset');
				}

				if ( $(this).data('src') ) {
					$(this).attr('src', $(this).data('src'));
					$(this).removeAttr('data-src');
				}			
			}
		});	
	});
};